import { IndexExpense } from "../../index-expense";

export class AddCampaignInit {
    dataId: IndexExpense;
    UpdateListProducts: boolean;
    add_comapin: boolean;
    constructor(dataId,UpdateListProducts,add_comapin = null){
        this.dataId = dataId;
        this.UpdateListProducts = UpdateListProducts;
        if (add_comapin) {
            this.add_comapin = add_comapin;
        }
        
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/add-campaign/add-campaign-init.ts